export default "__VITE_ASSET__Dabrocc6__"